import { Component, OnDestroy, signal, WritableSignal } from '@angular/core'
import { Router, RouterModule, NavigationEnd } from '@angular/router'
import { UserService } from 'src/app/services/user.service'
import { filter, Subscription } from 'rxjs'

@Component({
	selector: 'gwc-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	imports: [
		RouterModule
	]
})

export class LoginComponent implements OnDestroy {
	protected setup: WritableSignal<boolean> = signal(false)
	private routerSubscription?: Subscription

	constructor(
		private userService: UserService,
		private router: Router 
	) {
		this.userCheck()
		this.setup.set(this.router.routerState.snapshot.url === '/setup')
		
		this.routerSubscription = this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd)
			)
			.subscribe((event: NavigationEnd) => {
				this.setup.set(event.urlAfterRedirects === '/setup')
			})
	}

	ngOnDestroy(): void {
		this.routerSubscription?.unsubscribe()
	}

	private userCheck(): void {
		this.userService.check()
			.subscribe(response => {
				if (response.uuid) {
					if (this.setup()) {
						if (!response.new) return this.router.navigate(['/orders'])
					} else {
						if (response.new) return this.router.navigate(['/setup'])
						
						return this.router.navigate(['/orders'])
					}
				}

				return
			})
	}
}
